export const LOCATION_TYPE = 1
export const DEVICE_TYPE = 2
export const USER_TYPE = 4

export const ADD_EVENT = 4
export const EDIT_EVENT = 5
export const CAMERA_SETTINGS_VIEWED = 11
export const SINGLE_CAMERA_VIEWED = 10
export const CAMERA_SETTINGS_CHANGED = 12

// Gap between videojs segment and KVS fragment
export const KVS_AND_VIDEO_GAP = 48
// Per camera side require
export const SD_AND_VIDEO_GAP = 1000

//Smart Search sensitivity default value 30
export const SMART_SEARCH_SENSITIVITY = 35

export const AUDIT_ENTITY_TYPE = Object.freeze({
  SYSTEM: 1,
  USER: 2,
  NVR: 3,
  CAMERA: 4,
  CASE: 5,
})

export const AUDIT_ENTITY_ACTION_TYPE = Object.freeze({
  LOGIN: 1,
  ACCOUNT_LOCKED: 2,
  ADD_USER: 3,
  DELETE_USER: 4,
  CHANGE_ROLE: 5,
  ENABLE_USER: 6,
  DISABLE_USER: 7,
  ADD_NVR: 8,
  DELETE_NVR: 9,
  POWER_CYCLE: 10,
  UPDATE_RETENTION_PACKAGE: 11,
  ADD_CAMERA: 12,
  DELETE_CAMERA: 13,
  ADJUST_SETTINGS: 14,
  ACTIVATE_CAMERA: 15,
  DEACTIVATE_CAMERA: 16,
  VIEW_LIVE_CAMERA: 17,
  PLAYBACK_VIDEO: 18,
  EXPORT_CLIP: 19,
  CREATE_SCREENSHOT: 20,
  CREATE_CASE: 21,
  ADD_CLIP_TO_CASE: 22,
  DELETE_CASE: 23,
  SHARE_CASE: 24,
  CHANGE_CASE_DETAILS: 25,
})

export const SCHEDULE_TYPE = Object.freeze({
  NOTIFICATION: 0,
  ANALYTICS: 1,
})

export const ARMING_MODE = Object.freeze({
  ARMED: 0,
  DISARMED: 1,
})
